import { runInAction } from 'mobx';
import { getOrderItems } from '../../selectors/items/get-order-items';
import { getOrderSelections } from '../../selectors/order/get-order-selections';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
import { mapInProgressItemToOrderItemLines } from '../../utils/items/mappers/map-in-progress-item-to-order-item-lines';
export const addInProgressItemsToOrder = () => {
    const { inProgressItems } = temporaryOrderDomainStore.data;
    const orderSelections = getOrderSelections();
    const newItems = createOrderItemsFromInProgressItems(inProgressItems);
    const orderItems = getOrderItems();
    runInAction(() => {
        orderSelections.items = [...orderItems, ...newItems];
        temporaryOrderDomainStore.data.inProgressItems = inProgressItems.filter(i => i.id !== inProgressItems[0].id);
    });
};
const createOrderItemsFromInProgressItems = (inProgressItems) => {
    return inProgressItems.reduce((acc, inProgressItem) => {
        acc.push(...mapInProgressItemToOrderItemLines(inProgressItem));
        return acc;
    }, []);
};
